import { cn } from '../../lib/cn'

interface SectionProps {
  id?: string
  className?: string
  containerClassName?: string
  container?: boolean
  bleed?: boolean
  as?: 'section' | 'div' | 'article' | 'aside'
  children: React.ReactNode
  ariaLabel?: string
}

export function Section({
  id,
  className,
  containerClassName,
  container = true,
  bleed = false,
  as: Tag = 'section',
  children,
  ariaLabel,
}: SectionProps) {
  return (
    <Tag id={id} aria-label={ariaLabel} className={cn('relative', className)}>
      {container ? (
        <div className={cn(bleed ? 'container-bleed' : 'container-x', containerClassName)}>{children}</div>
      ) : (
        children
      )}
    </Tag>
  )
}
